import EntityModel from '@/common/models/entity-model';

export default class SegmentUserModel extends EntityModel {
    hydrate({
        id = null,
        name = null,
    } = {}) {
        this.id = id;
        this.name = name;
    }

    getPayload() {
        return {
            id: this.id,
            name: this.name,
        };
    }
}
